import { forwardRef, MouseEventHandler } from 'react';

import styled from 'styled-components';

import { ColorChip } from './ColorChip';

import { ChevronDownOutlined } from '@aircall/icons';
import { Flex, Box } from '@aircall/tractor-v2';
import { OptionValueType } from '@components/Select';

const FlexContainer = styled(Flex)`
  justify-content: space-between;
  border: 1px solid #d9d9d6;
  border-radius: 8px;
  background-color: #fff;
`;

export const TagColorPickerInput = forwardRef<
  HTMLDivElement,
  { value: OptionValueType; dataTest: string; onClick?: MouseEventHandler<HTMLDivElement> }
>((props, ref) => {
  const { value, onClick, dataTest } = props;

  return (
    <FlexContainer
      borderRadius='8px'
      border='1px solid'
      borderColor='neutral-300'
      p='xs'
      cursor='pointer'
      ref={ref}
      onClick={onClick}
      data-test={dataTest}
    >
      <ColorChip
        data-test={`${dataTest}-input-color-chip`}
        color={(value as string) || 'neutral-200'}
        outlined={!value}
      />
      <Box ml='xxxs'>
        <ChevronDownOutlined />
      </Box>
    </FlexContainer>
  );
});
